import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { PlatformGlobalService } from '../../service/platform-global.service';
import { DashboardService } from 'src/app/pages/dashboard/service/dashboard.service';
import { SidenavService } from '../../sidenav/sidenav.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';
import { HostListener } from '@angular/core';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'prep-toolbar-resources',
  templateUrl: './toolbar-resources.component.html',
  styleUrls: ['./toolbar-resources.component.scss'],
})
export class ToolbarResourcesComponent implements OnInit {
  @ViewChild('triggerBtn', { read: ElementRef }) triggerBtn: ElementRef;
  @ViewChild('menuPanel') menuPanel: ElementRef;

  isOpen: boolean;
  videourl: string;

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  isSubmenuOpen = false;

  constructor(
    private router: Router,
    private snackbar: MatSnackBar,
    private platformGlobalService: PlatformGlobalService,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        '🌍 Language changed:',
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isOpen) {
      this.closeAndReturnFocus();
    }
  }

  ngOnInit() {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      setTimeout(() => this.focusItemByIndex(0));
    }
  }

  onClickOutside() {
    this.isOpen = false;
  }

  closeAndReturnFocus() {
    this.isOpen = false;
    this.triggerBtn?.nativeElement?.focus();
  }

  onMenuKeydown(event: KeyboardEvent) {
    const items = this.getMenuItems();
    if (items.length === 0) return;
    const current = items.indexOf(document.activeElement as HTMLElement);

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.focusItem(items, current < items.length - 1 ? current + 1 : 0);
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.focusItem(items, current > 0 ? current - 1 : items.length - 1);
        break;
      case 'Home':
        event.preventDefault();
        this.focusItem(items, 0);
        break;
      case 'End':
        event.preventDefault();
        this.focusItem(items, items.length - 1);
        break;
      case 'Tab':
        this.closeAndReturnFocus();
        break;
    }
  }

  private getMenuItems(): HTMLElement[] {
    const panel = this.menuPanel?.nativeElement;
    if (!panel) return [];
    return Array.from(panel.querySelectorAll('[role="menuitem"]'));
  }

  private focusItem(items: HTMLElement[], index: number) {
    items.forEach(el => el.setAttribute('tabindex', '-1'));
    items[index]?.setAttribute('tabindex', '0');
    items[index]?.focus();
  }

  private focusItemByIndex(index: number) {
    const items = this.getMenuItems();
    if (items.length > 0) {
      this.focusItem(items, index);
    }
  }

  clickGoToResources() {
    this.router.navigate(['/resources']);
  }

  clickGoTpQuickStartGuide() {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = 'assets/document/PREP-Quick-Start-Guide.pdf';
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  clickGoToTraning() {
    const token = localStorage.getItem('token');
    const backend: string = environment.backend;
    const baseUrl = window.location.origin;
    const loginUrl = baseUrl + '/login';
    // Dev Env
    // const trainingURL = `https://dev-prep-training-course.netlify.app/prep-course/qwe98asd76lkjh32/${token}/poi45mnz67trew9/${encodeURIComponent(loginUrl)}/zas12xcv90plok8/${encodeURIComponent(backend)}/hgf67bvc43ujmn5`;
    
    // Prod Env
    const trainingURL = `https://prep-training-course.netlify.app/prep-course/qwe98asd76lkjh32/${token}/poi45mnz67trew9/${encodeURIComponent(loginUrl)}/zas12xcv90plok8/${encodeURIComponent(backend)}/hgf67bvc43ujmn5`;

    if (token !== '') {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', trainingURL);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      this.snackbar.open(
        'Training Course not Available for this user',
        '',
        {
          duration: 10000,
        }
      );
    }
  }

  toggleSubmenu(): void {
    this.isSubmenuOpen = !this.isSubmenuOpen;
  }

  clickSubmenuItem(item: string): void {
    console.log(`Submenu item clicked: ${item}`);
    // Add your logic here for handling submenu item clicks
    switch (item) {
      case 'item1': {
        let youtubelink1 =
          'https://www.youtube.com/playlist?list=PLTAD7sYmpKxsONR3nzRru6-CUnbFVwk8N';
        window.open(youtubelink1, '_blank');
        break;
      }
      case 'item2': {
        let youtubelink2 =
          'https://www.youtube.com/playlist?list=PLTAD7sYmpKxv7zFrBDj1BopqQAYDEbMp0';
        window.open(youtubelink2, '_blank');
        break;
      }
      case 'item3': {
        let youtubelink3 =
          'https://www.youtube.com/playlist?list=PLTAD7sYmpKxuuNV8xdUfrd8Jp2I0es2BG';
        window.open(youtubelink3, '_blank');
        break;
      }
      case 'item4': {
        let youtubelink4 =
          'https://www.youtube.com/playlist?list=PLTAD7sYmpKxsMmZX1YGHnXpwWcuvNLB7r';
        window.open(youtubelink4, '_blank');
        break;
      }
      case 'item5': {
        let youtubelink5 =
          'https://www.youtube.com/playlist?list=PLTAD7sYmpKxvK6t2GqsdtY7JQqED-7Q3W';
        window.open(youtubelink5, '_blank');
        break;
      }
      case 'item6': {
        let youtubelink6 =
          'https://www.youtube.com/playlist?list=PLTNa0rLK0U1k';
        window.open(youtubelink6, '_blank');
        break;
      }
      case 'item7': {
        let youtubelink7 =
          'https://www.youtube.com/playlist?list=PLDM7aL-synac';
        window.open(youtubelink7, '_blank');
        break;
      }
      case 'item8': {
        let youtubelink8 =
          'https://www.youtube.com/playlist?list=PLCAmcrsDutkk';
        window.open(youtubelink8, '_blank');
        break;
      }
    }
  }
}
